import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08a449de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "detail",
  class: "detail"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "飼養管理者", -1))
const _hoisted_3 = { class: "description-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "個体識別番号", -1))
const _hoisted_5 = { class: "description-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "調査日時", -1))
const _hoisted_7 = {
  key: 0,
  class: "description-content"
}
const _hoisted_8 = {
  key: 1,
  class: "description-content"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "生年月日", -1))
const _hoisted_10 = { class: "description-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "調査時月齢", -1))
const _hoisted_12 = { class: "description-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "性別", -1))
const _hoisted_14 = { class: "description-content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "父", -1))
const _hoisted_16 = { class: "description-content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "母の父", -1))
const _hoisted_18 = { class: "description-content" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "母の母の父", -1))
const _hoisted_20 = { class: "description-content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "2. AI-MEAT解析結果", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "解析実行ユーザー", -1))
const _hoisted_23 = { class: "description-content" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "最終解析日時", -1))
const _hoisted_25 = { class: "description-content" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "BMS No.", -1))
const _hoisted_27 = { class: "description-content" }
const _hoisted_28 = { class: "description-content__rank5proba" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "僧帽筋厚さ", -1))
const _hoisted_30 = {
  key: 0,
  class: "description-content"
}
const _hoisted_31 = {
  key: 1,
  class: "description-content"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, [
  /*#__PURE__*/_createTextVNode("僧帽筋上皮"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("皮下脂肪厚さ")
], -1))
const _hoisted_33 = {
  key: 0,
  class: "description-content"
}
const _hoisted_34 = {
  key: 1,
  class: "description-content"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "皮下脂肪厚さ", -1))
const _hoisted_36 = {
  key: 0,
  class: "description-content"
}
const _hoisted_37 = {
  key: 1,
  class: "description-content"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "広背筋厚さ", -1))
const _hoisted_39 = {
  key: 0,
  class: "description-content"
}
const _hoisted_40 = {
  key: 1,
  class: "description-content"
}
const _hoisted_41 = {
  key: 0,
  class: "edit-button",
  style: {"margin-top":"auto","margin-left":"auto"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "3. 類似画像", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "BMS No.", -1))
const _hoisted_44 = { class: "description-content" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "僧帽筋厚さ", -1))
const _hoisted_46 = { class: "description-content" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, [
  /*#__PURE__*/_createTextVNode("僧帽筋上皮"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("皮下脂肪厚さ")
], -1))
const _hoisted_48 = { class: "description-content" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "皮下脂肪厚さ", -1))
const _hoisted_50 = { class: "description-content" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "広背筋厚さ", -1))
const _hoisted_52 = { class: "description-content" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-image-slot" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-picture-outline" })
], -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "4. 枝肉データベース情報", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "枝肉重量", -1))
const _hoisted_56 = { class: "description-content" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "バラの厚さ", -1))
const _hoisted_58 = { class: "description-content" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "皮下脂肪厚", -1))
const _hoisted_60 = { class: "description-content" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "歩留基準値", -1))
const _hoisted_62 = { class: "description-content" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "脂肪交雑", -1))
const _hoisted_64 = { class: "description-content" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "ロース芯面積", -1))
const _hoisted_66 = { class: "description-content" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-label" }, "ロース芯面積(画像解析値)", -1))
const _hoisted_68 = { class: "description-content" }
const _hoisted_69 = { class: "image-with-caption" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-image-slot" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-picture-outline" })
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-caption" }, "枝肉横断面画像", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_image = _resolveComponent("el-image")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.prediction?.shootingDate) + " - " + _toDisplayString(_ctx.prediction?.cattleId), 1),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          class: "print",
          span: 20,
          offset: 2
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, { class: "noprint" }, {
              default: _withCtx(() => [
                _createTextVNode("印刷")
              ]),
              _: 1
            })), [
              [_directive_print]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 20,
          offset: 2
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", null, [
              _createTextVNode(" 1. 個体情報 "),
              (!_ctx.isFarmerUser)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "noprint",
                    type: "primary",
                    size: "small",
                    loading: _ctx.isReloadingCattleInfo,
                    disabled: !_ctx.prediction?.cattleId,
                    style: {"margin-left":"16px"},
                    onClick: _ctx.reloadCattleInfo
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 個体情報を再取得 ")
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_descriptions, {
              direction: "vertical",
              column: 4,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { span: "4" }, {
                  label: _withCtx(() => [
                    _hoisted_2
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.display(_ctx.prediction?.cattle?.farmer)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_4
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.display(_ctx.prediction?.cattleId)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_6
                  ]),
                  default: _withCtx(() => [
                    (_ctx.prediction?.shotAt)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.display(_ctx.formatDate(_ctx.prediction.shotAt))), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.display(_ctx.formatDate(_ctx.prediction?.shootingDate, 'yyyy-MM-dd'))), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_9
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.display(_ctx.formatDate(_ctx.prediction?.cattle?.birthday, 'yyyy-MM-dd'))), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_11
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.display(_ctx.moonAge)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_13
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.display(_ctx.prediction?.cattle?.sex)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_15
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.display(_ctx.prediction?.cattle?.father)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_17
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.display(_ctx.prediction?.cattle?.mothersFather)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_19
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.display(_ctx.prediction?.cattle?.mothersMothersFather)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 20,
          offset: 2
        }, {
          default: _withCtx(() => [
            _hoisted_21,
            _createVNode(_component_el_descriptions, {
              direction: "vertical",
              column: 5,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { span: 3 }, {
                  label: _withCtx(() => [
                    _hoisted_22
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.display(_ctx.prediction?.user.name)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { span: 2 }, {
                  label: _withCtx(() => [
                    _hoisted_24
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.display(_ctx.formatDate(_ctx.prediction?.updatedAt))), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_26
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                      _createTextVNode(_toDisplayString(_ctx.display(_ctx.prediction?.result.BMS)) + " ", 1),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.display(_ctx.getRank5Percentage(), {
                    prefix: ' (5等級確率',
                    suffix: '%)',
                    placeholder: '',
                  })), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_29
                  ]),
                  default: _withCtx(() => [
                    (_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_input, {
                              style: {"margin-right":"-160px","width":"80px"},
                              modelValue: _ctx.trapeziusThickness,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trapeziusThickness) = $event)),
                              type: "number",
                              min: "0"
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.display(_ctx.prediction?.exampleSearch?.trapeziusThickness, { suffix: ' cm' })), 1)
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_32
                  ]),
                  default: _withCtx(() => [
                    (_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_input, {
                              style: {"margin-right":"-160px","width":"80px"},
                              modelValue: _ctx.trapeziusSubcutaneousFatThickness,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trapeziusSubcutaneousFatThickness) = $event)),
                              type: "number",
                              min: "0"
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.display(_ctx.prediction?.exampleSearch?.trapeziusSubcutaneousFatThickness, {
                    suffix: ' cm',
                  })), 1)
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_35
                  ]),
                  default: _withCtx(() => [
                    (_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_input, {
                              style: {"margin-right":"-160px","width":"80px"},
                              modelValue: _ctx.subcutaneousFatThickness,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.subcutaneousFatThickness) = $event)),
                              type: "number",
                              min: "0"
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.display(_ctx.prediction?.exampleSearch?.subcutaneousFatThickness, { suffix: ' cm' })), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _hoisted_38
                  ]),
                  default: _withCtx(() => [
                    (_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_input, {
                              style: {"margin-right":"-160px","width":"80px"},
                              modelValue: _ctx.latissimusThickness,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.latissimusThickness) = $event)),
                              type: "number",
                              min: "0"
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.display(_ctx.prediction?.exampleSearch?.latissimusThickness, { suffix: ' cm' })), 1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!_ctx.isFarmerUser)
              ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 24,
                      style: {"display":"flex"}
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isEditing)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createVNode(_component_el_button_group, { class: "edit-button" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    icon: _ctx.Check,
                                    circle: "",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.doEditing()))
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_el_button, {
                                    icon: _ctx.Close,
                                    circle: "",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancelEditing()))
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              icon: _ctx.EditPen,
                              circle: "",
                              class: "edit-button",
                              style: {"margin-top":"auto","margin-left":"auto"},
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleEditing()))
                            }, null, 8, ["icon"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.example)
      ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 20,
              offset: 2
            }, {
              default: _withCtx(() => [
                _hoisted_42,
                _createVNode(_component_el_descriptions, {
                  direction: "vertical",
                  column: 5,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_43
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.display(_ctx.example.bms)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_45
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.display(_ctx.example.trapeziusThickness, { suffix: ' cm' })), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_47
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.display(_ctx.example.trapeziusSubcutaneousFatThickness, { suffix: ' cm' })), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_49
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.display(_ctx.example.subcutaneousFatThickness, { suffix: ' cm' })), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_51
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.display(_ctx.example.latissimusThickness, { suffix: ' cm' })), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { justify: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          src: _ctx.example.image,
                          "preview-src-list": [_ctx.example.image],
                          "append-to-body": "",
                          "hide-on-click-modal": "",
                          fit: "scale-down",
                          class: "example-image"
                        }, {
                          error: _withCtx(() => [
                            _hoisted_53
                          ]),
                          _: 1
                        }, 8, ["src", "preview-src-list"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.prediction?.carcass)
      ? (_openBlock(), _createBlock(_component_el_row, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 20,
              offset: 2
            }, {
              default: _withCtx(() => [
                _hoisted_54,
                _createVNode(_component_el_descriptions, {
                  direction: "vertical",
                  column: 6,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_55
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.display(_ctx.prediction.carcass.wholeWeight, { suffix: ' kg' })), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_57
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.display(_ctx.prediction.carcass.ribThickness, { suffix: ' cm' })), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_59
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.display(_ctx.prediction.carcass.subcutaneousFatThickness, { suffix: ' cm' })), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_61
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.display(_ctx.prediction.carcass.yieldScore)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_63
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.display(_ctx.prediction.carcass.bmsNo)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_65
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.display(_ctx.prediction.carcass.ribEyeAreaByGrader, { suffix: ' cm²' })), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, null, {
                      label: _withCtx(() => [
                        _hoisted_67
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.display(_ctx.prediction.carcass.ribEyeArea, { suffix: ' cm²' })), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { justify: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_69, [
                          _createVNode(_component_el_image, {
                            src: _ctx.prediction.carcass.crossSectionImgUrl,
                            "preview-src-list": [_ctx.prediction.carcass.crossSectionImgUrl],
                            "append-to-body": "",
                            "hide-on-click-modal": "",
                            fit: "scale-down",
                            class: "cross-section-image"
                          }, {
                            error: _withCtx(() => [
                              _hoisted_70
                            ]),
                            _: 1
                          }, 8, ["src", "preview-src-list"]),
                          _hoisted_71
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}